module.exports = __webpack_public_path__ + "3a1371a422ca9fd33b0f4b6d5604c83b.svg";